export default __webpack_public_path__ + "static/media/center-classrooms.dd521154.svg";